<template>
  <router-view />
</template>

<script>
import roles from "store/role.store";
import guReports from "store/guReports.store";

const ROLES_STORE = "roles";
const GU_REPORTS = "guReports";

export default {
  beforeCreate() {
    this.$store.registerModule(ROLES_STORE, roles);
    this.$store.registerModule(GU_REPORTS, guReports);
  },
  beforeDestroy() {
    this.$store.unregisterModule(ROLES_STORE);
    this.$store.unregisterModule(GU_REPORTS);
  },
};
</script>
